import { render, staticRenderFns } from "./TextInputContextMenu.vue?vue&type=template&id=0a4dd664&scoped=true&"
import script from "./TextInputContextMenu.vue?vue&type=script&lang=ts&"
export * from "./TextInputContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TextInputContextMenu.vue?vue&type=style&index=0&id=0a4dd664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4dd664",
  null
  
)

export default component.exports